import React from "react";

export default function Section5() {
  const shopifyOnlyServices = [
    {
      title: "Custom Shopify Design",
      description:
        "We build custom Shopify websites in Dubai that perfectly align with your brand’s identity. From typography to animations, every element is designed to make your site stand out and convert visitors into loyal customers.",
    },
    {
      title: "Shopify Store Development",
      description:
        "Our developers create clean, scalable Shopify themes optimized for performance and user experience. Every store we build is mobile-friendly, cross-browser tested, and designed with conversions in mind.",
    },
    {
      title: "Shopify Plus Development",
      description:
        "Unlock the full potential of Shopify Plus with our specialized development services. We handle custom checkout flows, third-party integrations, and ERP/CRM solutions, ensuring your business runs smoothly as it scales.",
    },
    {
      title: "App Integration and API Work",
      description:
        "Need more functionality? We help integrate third-party apps and build custom solutions using Shopify API to make your store do exactly what you need.",
    },
    {
      title: "Migration to Shopify",
      description:
        "We make Shopify migration services seamless. Our team will migrate your product data, content, customers, and orders from platforms like WooCommerce, Magento, BigCommerce, or custom systems to Shopify with zero downtime or data loss.",
    },
    {
      title: "Support and Maintenance",
      description:
        "Post-launch support is crucial. We provide ongoing Shopify maintenance services in UAE, from performance audits and technical troubleshooting to feature updates and design improvements.",
    },
  ];

  return (
    <div className="w-full Section4 mt-[14%] md:mt-[4%]">
      <div className="w-full mx-auto section4-container">
        <h2 className="w-[90%] md:w-[61%] mx-auto text-center text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] text-[#151515] font-bold my-[0.67em]">
          Our Shopify Development Services in UAE
        </h2>

        <div className="boxes w-[85%] xs:w-full md:w-[85%] flex justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] flex-wrap mx-auto p-[2%_0px_4%_0px]">
          {/* Shopify-only Cards */}
          {shopifyOnlyServices.map((service, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${
                index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
              }`}
            >
              <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h2>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
